import React from 'react';
import styled from 'styled-components';
import { Text } from 'rebass/styled-components';

import PublicEnv from 'shared/utils/public-env';
import useTranslation from 'hooks/use-translation';
import useUI from 'hooks/use-ui';
import { MobileEcommTermsLink } from 'src/mobile-ecomm/components/terms-link';
import { useCustomTermsUrl } from 'src/utils/misc-utils';

export function Terms() {
  const { t } = useTranslation();
  const { isMobileEcommApp, isDutchieMain } = useUI();
  const customTermsUrl = useCustomTermsUrl();

  const href = !isDutchieMain && customTermsUrl ? customTermsUrl : `${PublicEnv.consumerUrl}/terms`;

  return (
    <Text color='#606369' fontSize='13px'>
      {t('checkout-signup.agree', `By creating an account you agree to these `)}
      {isMobileEcommApp ? (
        <MobileEcommTermsLink text='Terms' />
      ) : (
        <StyledLink rel='noopener noreferrer' target='_blank' href={href}>
          {t('checkout-signup.terms', `Terms`)}
        </StyledLink>
      )}
      .
    </Text>
  );
}

const StyledLink = styled.a`
  color: #0b99e6;
`;
